export default __webpack_public_path__ + "static/media/preloader.0ac0e9d1.gif";